export default {
    title: 'Gente',
    'placeholder': 'Gente',
   
    'content1': `Muitas pessoas colaboraram com o Projeto Mil Folhas nos últimos 22 anos. Alguns nomes já foram esquecidos, infelizmente, mas a dedicação de cada um se faz presente nas mais de 320 mil árvores que foram plantadas durante esses anos. Abaixo, uma lista de alguns nomes, com os sobrenomes em ordem alfabética, e um número de pessoas cujos nomes reais nunca soubemos, mas apenas os apelidos. O importante é que suas contribuições serão sempre lembradas, e muito valorizadas:`,

    'kids': 'Alunos Da E.E. João Kopke Durante A Caminhada Da Escola Até A Área Do Plantio, Em Frente A Um Deslizamento De Terra, Porque A Encosta Estava Desmatada.'
   
  };
  